export default "__VITE_ASSET__Bsf8UpZm__"